<template>
  <div class="">

    <div v-if="kidSelected">
      <LoginAsKidCard :kid=kidSelected ></LoginAsKidCard>
      <RemoveKidCard :kid=kidSelected ></RemoveKidCard>
      <GotoTransactionsCard :kid=kidSelected ></GotoTransactionsCard>
    </div>
    <div v-else class="title">
      Select a kid to see information here.
    </div>
</div>

</template>

<script>
import {mapState} from 'vuex'
import LoginAsKidCard from './LoginAsKidCard'
import RemoveKidCard from './RemoveKidCard'
import GotoTransactionsCard from './GotoTransactionsCard'

export default {
  name: 'Kid',
  components: {
    LoginAsKidCard, RemoveKidCard, GotoTransactionsCard
  },
  props: {

  },
  computed: {
    ...mapState({
      kidSelected: state => state.parent.kidSelected
    })
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
